<div *ngIf="WorkflowID==8 && state.NAME == 'Creation State'">
  <div class="row" *ngIf="WorkflowID==8 && state.NAME == 'Creation State' && (screenName == 'mytask' || screenName == 'myinvolved' || screenName == 'manage')"><div class="col"><h3>With COE ID</h3></div></div>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <div>
        <mat-form-field class="column">
          <mat-label>Filter</mat-label>
          <input matInput (keyup)="applyFilterSyncInitial($event)" placeholder="Filter items below">
        </mat-form-field>
      </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <div class="margin-top-sm table-responsive">
        <mat-table [dataSource]="dataSourceSyncInitial" class="mat-table" matSort #sort2="matSort"
        [hidden]="dataSourceSyncInitial.data.length === 0">
          <ng-container matColumnDef="ID">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <button mat-icon-button color="primary" matTooltip="Edit" *ngIf="screenName=='mytask'">
                <mat-icon (click)="goToPage(element, element.NODE_COES[0].CO?.COE_SURVEY?.SURVEY_ID)">edit</mat-icon>
              </button>

              <button mat-icon-button color="primary" matTooltip="View" *ngIf="screenName!='mytask'">
                <mat-icon (click)="goToPage(element, element.NODE_COES[0].CO?.COE_SURVEY?.SURVEY_ID)">visibility</mat-icon>
              </button>

              <confirm-popover *ngIf="screenName=='mytask'" [buttonType]="'mini-icon'" [icon]="'delete'" [color]="'warn'"
                [popoverMsg]="'Delete Confirmation'" [popoverConfirmText]="'Delete'" [popoverConfirmColor]="'warn'"
                [tooltip]="'Delete'" (onConfirm)="deleteCoe(element.NODE_COES[0].CO?.ID)">
              </confirm-popover>
              <mat-icon *ngIf="deleteLoading && deleteCoeID == element.NODE_COES[0].CO?.ID" class="v-align-middle">
                <mat-spinner diameter="20"></mat-spinner>
              </mat-icon>
            </td>
          </ng-container>

          <ng-container matColumnDef="CREATED_DATE">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
            <td mat-cell *matCellDef="let element" matTooltip="{{element.createdToolTip}}"> {{element.CREATED_DATE | date:'MM/dd/yyyy hh:mm a'}} </td>
          </ng-container>

          <ng-container matColumnDef="RECRUITER_NAME">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Recruiter</th>
            <td mat-cell *matCellDef="let element"><span
                *ngIf="element.NODE_COES && element.NODE_COES.length > 0">{{element.NODE_COES?.[0]?.CO?.RECRUITER_NAME}}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="UPDATED_DATE">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Updated</th>
            <td mat-cell *matCellDef="let element" matTooltip="{{element.updatedToolTip}}"> {{element.lastestUpdatedDate | date:'MM/dd/yyyy hh:mm a'}} </td>
          </ng-container>

          <ng-container matColumnDef="SURVEY_ID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>COE Type</th>
            <td mat-cell *matCellDef="let element">
              <span *ngIf="element.NODE_COES[0].CO?.COE_SURVEY?.SURVEY_ID == 2">eCoe</span>
              <span *ngIf="element.NODE_COES[0].CO?.COE_SURVEY?.SURVEY_ID == 7">Paper Coe</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="COE_ID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Coe ID</th>
            <td mat-cell *matCellDef="let element">
              <span>
                {{element.NODE_COES?.[0]?.COES_ID}}
              </span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="cdisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: cdisplayedColumns;"></tr>
        </mat-table>
      </div>
    </div>

    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <mat-paginator #paginator2 [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons
        aria-label="Select page of elements">
      </mat-paginator>
    </div>
  </div>
</div>


<div class="row" [hidden]="matTableWithCoeNumber.data.length === 0">
  <div class="row" *ngIf="WorkflowID==8 && state.NAME == 'Creation State' && (screenName == 'mytask' || screenName == 'myinvolved' || screenName == 'manage')"><div class="col"><h3>With COE Number</h3></div></div>
  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
    <div>
      <mat-form-field class="column">
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="applyFilterWithCoeNumber($event)" placeholder="Filter items below">
      </mat-form-field>
    </div>
  </div>
  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
    <div class="margin-top-sm table-responsive">
      <mat-table [dataSource]="matTableWithCoeNumber" class="mat-table" matSort #sort1="matSort"
      [hidden]="matTableWithCoeNumber.data.length === 0">
        <ng-container matColumnDef="ID">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button color="primary" matTooltip="View" *ngIf="(screenName=='queued') || (screenName=='mytask' && workflow.WORKFLOW_NODE_TYPES.NAME == 'Account Creation') || (screenName=='myinvolved') || (screenName=='myarchive') || (screenName=='manage')">
              <mat-icon *ngIf="element.NODE_COES && element.NODE_COES.length > 0"
                (click)="goToPageView(element, element.NODE_COES[0].CO?.COE_SURVEY?.SURVEY_ID)">visibility</mat-icon>
              <mat-icon *ngIf="!element.NODE_COES" (click)="goToPageView(element)">visibility</mat-icon>
            </button>

            <button mat-icon-button color="primary" [matTooltip]="element.isDenied ? mesg : 'Add to My Tasks'"
              *ngIf="screenName=='queued' && !element.NODE_EDITING"
              (click)="onAddClick(element)"><!-- (click)="chooseToEditNode(element)"-->
              <mat-icon [color]="element.isDenied==true ? 'warn' : 'primary'">{{element.isDenied==true ? 'block' :
                'add'}}</mat-icon>
            </button>

            <button mat-icon-button color="primary" matTooltip="Edit"
              *ngIf="screenName=='mytask' && workflow.WORKFLOW_NODE_TYPES.NAME !== 'Account Creation'">
              <mat-icon (click)="goToPageEdit(element, element.NODE_COES[0].CO?.COE_SURVEY?.SURVEY_ID)">edit</mat-icon>
            </button>

            <button mat-icon-button color="primary" matTooltip="Release this item"
              *ngIf="screenName=='mytask' && element.ID && state.NAME !== 'Recruiter Fix State' && !((workflow.NAME == 'COE Workflow' && state.NAME == 'Creation State') || ((workflow.NAME == 'COE-2017 Workflow' || workflow.NAME == 'COE-2023 Workflow') && state.NAME == 'Creation State'))"
              (click)="ChooseToNotEditNode(element)">
              <mat-icon>remove</mat-icon>
            </button>

            <button mat-icon-button color="primary" matTooltip="Reassign Item"
              *ngIf="screenName=='manage' && state.NAME == 'Review State'">
              <mat-icon (click)="goToAssignNode(element, 'assign')">account_box</mat-icon>
            </button>

            <button mat-icon-button color="primary" matTooltip="Change Item State"
              *ngIf="screenName=='manage' && state.NAME == 'Review State'">
              <mat-icon (click)="goToAssignNode(element, 'change')">assignment</mat-icon>
            </button>

            <!--ng-if="!denied && !hasEditors && !inCompletionState() && hasNodeCreatorPermission()"-->
          </td>
        </ng-container>

        <ng-container matColumnDef="CREATED_DATE">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
          <td mat-cell *matCellDef="let element" matTooltip="{{element.createdToolTip}}"> {{element.CREATED_DATE |
            date:'MM/dd/yyyy hh:mm a'}} </td>
        </ng-container>

        <ng-container matColumnDef="UPDATED_DATE">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Updated</th>
          <td mat-cell *matCellDef="let element" matTooltip="{{element.updatedToolTip}}"> {{element.lastestUpdatedDate |
            date:'MM/dd/yyyy hh:mm a'}} </td>
        </ng-container>

        <ng-container matColumnDef="FIRST_NAME">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.NODE_ACCOUNT_REQUESTS && element.NODE_ACCOUNT_REQUESTS.length > 0">
              {{element.NODE_ACCOUNT_REQUESTS[0].ACCOUNT_REQUESTS.FIRST_NAME}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="LAST_NAME">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.NODE_ACCOUNT_REQUESTS && element.NODE_ACCOUNT_REQUESTS.length > 0">
              {{element.NODE_ACCOUNT_REQUESTS[0].ACCOUNT_REQUESTS.LAST_NAME}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="EMAIL">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.NODE_ACCOUNT_REQUESTS && element.NODE_ACCOUNT_REQUESTS.length > 0">
              {{element.NODE_ACCOUNT_REQUESTS[0].ACCOUNT_REQUESTS.EMAIL_ADDRESS}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="REGION">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Region</th>
          <td mat-cell *matCellDef="let element" matTooltip="{{element.regionName}}"><span
              *ngIf="element.NODE_REGIONS && element.NODE_REGIONS.length > 0">
              {{element.NODE_REGIONS[0].REGION.CODE}}
            </span></td>
        </ng-container>

        <ng-container matColumnDef="ORGANIZATION">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Organization</th>
          <td mat-cell *matCellDef="let element"><span
              *ngIf="element.NODE_REGIONS && element.NODE_REGIONS.length > 0">{{element.NODE_REGIONS[0].REGION.ORGANIZATION.NAME}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="Provisional School Name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Provisional School Name</th>
          <td mat-cell *matCellDef="let element">
            <span
              *ngIf="element.NODE_PROVISIONAL_SCHOOLS && element.NODE_PROVISIONAL_SCHOOLS.length > 0">{{element.NODE_PROVISIONAL_SCHOOLS[0].PROVISIONAL_SCHOOLS.SCHOOL_NAME}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="ProvSchool_COE_NUMBER">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>COE #</th>
          <td mat-cell *matCellDef="let element">
            <span
              *ngIf="element.NODE_PROVISIONAL_SCHOOLS && element.NODE_PROVISIONAL_SCHOOLS.length > 0">{{element.NODE_PROVISIONAL_SCHOOLS[0].PROVISIONAL_SCHOOLS.CO.COE_NUMBER}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="RECRUITER_NAME">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Recruiter</th>
          <td mat-cell *matCellDef="let element"><span
              *ngIf="element.NODE_COES && element.NODE_COES.length > 0">{{element.NODE_COES[0].CO.RECRUITER_NAME}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="CURRENT_CITY">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Current City</th>
          <td mat-cell *matCellDef="let element"><span
              *ngIf="element.NODE_COES && element.NODE_COES.length > 0">{{titleText(element.NODE_COES[0].CO.CURRENT_CITY)}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="COE_NUMBER">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>COE #</th>
          <td mat-cell *matCellDef="let element">
            <span
              *ngIf="element.NODE_COES && element.NODE_COES.length > 0">{{element.NODE_COES[0].CO.COE_NUMBER}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="SURVEY_ID">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>COE Type</th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.NODE_COES[0].CO?.COE_SURVEY?.SURVEY_ID == 2">eCoe</span>
            <span *ngIf="element.NODE_COES[0].CO?.COE_SURVEY?.SURVEY_ID == 7">Paper Coe</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="CURRENT_EDITOR">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Current Editor</th>
          <td mat-cell *matCellDef="let element">
            <span
              *ngIf="(screenName == 'myinvolved' || screenName == 'manage') && element.NODE_EDITING && element.NODE_EDITING.length > 0">{{element.NODE_EDITING[0].LOGIN_DETAILS.PERSON.FIRST_NAME}}
              {{element.NODE_EDITING[0].LOGIN_DETAILS.PERSON.LAST_NAME}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="CURRENT_STATUS">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
          <td mat-cell *matCellDef="let element">
            <div *ngIf="(element.NODE_HISTORIES && element.NODE_HISTORIES.length > 0)">
              <node-status-table-item [(node)]="element.NODE" [nodeId]="element.ID"
                [nodeHistory]="element.NODE_HISTORIES"></node-status-table-item>
            </div>
          </td>
        </ng-container>

        <!--ng-container matColumnDef="COE_NUMBER">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>COE #</th>
              <td mat-cell *matCellDef="let element">
                <span *ngIf="element.NODE_COES && element.NODE_COES.length > 0">{{element.NODE_COES[0].CO.COE_NUMBER}}</span>
                <span
                  *ngIf="element.NODE_PROVISIONAL_SCHOOLS && element.NODE_PROVISIONAL_SCHOOLS.length > 0">{{element.NODE_PROVISIONAL_SCHOOLS[0].PROVISIONAL_SCHOOLS.CO.COE_NUMBER}}</span>
              </td>
        </ng-container-->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </mat-table>
    </div>
  </div>
  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
    <mat-paginator #paginator1 [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons
      aria-label="Select page of elements">
    </mat-paginator>
  </div>
</div>

